module.exports = __webpack_public_path__ + "static/media/waterbath-with-rack-open.938755f5.svg";